const SupportedLanguages = {
    ARABIC: 'arabic',
    GERMAN: 'german',
    SPANISH: 'spanish',
    FRENCH: 'french',
    HEBREW: 'hebrew',
    ITALIAN: 'italian',
    JAPANESE: 'japanese',
    DUTCH: 'dutch',
    POLISH: 'polish',
    PORTUGUESE: 'portuguese',
    ROMANIAN: 'romanian',
    RUSSIAN: 'russian',
    TURKISH: 'turkish',
    CHINESE: 'chinese',
    ENGLISH: 'english',
    UKRAINIAN: 'ukrainian',
}
module.exports = SupportedLanguages
